export const SWITCH_OFFICE_PROFILE = 'SWITCH_OFFICE_PROFILE';
export const SWITCH_OFFICE_PROFILE_ERROR = 'SWITCH_OFFICE_PROFILE_ERROR';
export const SWITCH_OFFICE_PROFILE_REQUEST = 'SWITCH_OFFICE_PROFILE_REQUEST';
export const SWITCH_OFFICE_PROFILE_SUCCESS = 'SWITCH_OFFICE_PROFILE_SUCCESS';
